import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { AnimatePresence, motion } from "framer-motion";

import EcosystemItems from "../EcosystemItems";
import CommunityItems from "../CommunityItems";
import AboutItems from "../AboutItems";
import CrossIcon from "assets/landing/icons/burger-icons/CrossIcon";
import EcosystemIcon from "assets/landing/icons/burger-icons/EcosystemIcon";
import CommunityIcon from "assets/landing/icons/burger-icons/CommunityIcon";
import AboutIcon from "assets/landing/icons/burger-icons/AboutIcon";

type BurgerMenuProps = {
  isOpen: boolean;
  handleClose: () => void;
};

const BurgerMenu: React.FC<BurgerMenuProps> = ({ isOpen, handleClose }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={handleClose}>
      <AnimatePresence>
        {isOpen && (
          <Dialog.Portal forceMount>
            <Dialog.DialogOverlay className="fixed inset-0" />
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.15, ease: "easeOut" }}
              className="fixed top-0 right-0 z-[1200] m-[2vw]"
            >
              <Dialog.Content className="flex ">
                <Dialog.Title className="sr-only">Menu</Dialog.Title>

                {isOpen && (
                  <motion.div className="flex flex-col bg-[#F3F3F8] font-luxora-regular w-[75vw] shadow-custom burger-border p-[4.26vw] mb-[4.26vw]">
                    <div className="overflow-y-auto max-h-[80vh] py-2">
                      <div className="flex flex-col p-[2.13vw] mb-3 border border-white rounded-2xl">
                        <div className="w-full flex items-center justify-between mb-2 p-[2.13vw]">
                          <div className="flex items-center gap-[3.2vw]">
                            <div className="size-[2vw] max-lg:size-[7.46vw] flex items-center justify-center rounded-lg bg-white shadow-custom">
                              <EcosystemIcon
                                className={"size-[1.4vw] max-lg:size-[5.45vw]"}
                              />
                            </div>
                            <span className="text-black text-[1vw] max-lg:text-[3.73vw] leading-[1.1]">
                              Ecosystem
                            </span>
                          </div>
                          <button
                            onClick={handleClose}
                            className="size-[2vw] max-lg:size-[7.46vw] flex items-center justify-center rounded-lg bg-white shadow-custom"
                          >
                            <CrossIcon
                              className={"size-[1.4vw] max-lg:size-[5.45vw]"}
                            />
                          </button>
                        </div>
                        <EcosystemItems />
                      </div>
                      <div className="flex flex-col p-[2.13vw] mb-3 border border-white rounded-2xl">
                        <div className="w-full flex items-center justify-between mb-2 p-[2.13vw]">
                          <div className="flex items-center gap-[3.2vw]">
                            <div className="size-[2vw] max-lg:size-[7.46vw] flex items-center justify-center rounded-lg bg-white shadow-custom">
                              <CommunityIcon
                                className={"size-[1.4vw] max-lg:size-[5.45vw]"}
                              />
                            </div>
                            <span className="text-black text-[1vw] max-lg:text-[3.73vw] leading-[1.1]">
                              Community
                            </span>
                          </div>
                        </div>
                        <CommunityItems />
                      </div>
                      <div className="flex flex-col p-[2.13vw] border border-white rounded-2xl">
                        <div className="w-full flex items-center justify-between mb-2 p-[2.13vw]">
                          <div className="flex items-center gap-[3.2vw]">
                            <div className="size-[2vw] max-lg:size-[7.46vw] flex items-center justify-center rounded-lg bg-white shadow-custom">
                              <AboutIcon className={"size-[5vw]"} />
                            </div>
                            <span className="text-black text-[1vw] max-lg:text-[3.73vw] leading-[1.1]">
                              About
                            </span>
                          </div>
                        </div>
                        <AboutItems />
                      </div>
                    </div>
                  </motion.div>
                )}
              </Dialog.Content>
            </motion.div>
          </Dialog.Portal>
        )}
      </AnimatePresence>
    </Dialog.Root>
  );
};

export default BurgerMenu;
